/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ring_CustomersInputs */

const en_ring_customers = /** @type {(inputs: Ring_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retailers and buyers`)
};

/**
* | output |
* | --- |
* | "Retailers and buyers" |
*
* @param {Ring_CustomersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ring_customers = /** @type {((inputs?: Ring_CustomersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ring_CustomersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ring_customers(inputs)
});